<template>
  <main>
    <b-table responsive striped hover :items="items" :fields="fields"></b-table>
  </main>
</template>
<script>
export default {
  name: 'balancetableOther',
  props: ['items'],
  data () {
    return {
      fields: [
        {
          label: 'Dato',
          key: 'date_to',
          sortable: true
        },
        {
          label: 'Beløb',
          key: 'amount',
          sortable: true
        },
        {
          key: 'contactname',
          label: 'Møder',
          sortable: true
        },
        {
          key: 'note',
          label: 'Info',
          sortable: true
        }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// BalanceTableOther.vue?7bd3067d